import { render, staticRenderFns } from "./Signalr.vue?vue&type=template&id=45bf3ce9&scoped=true&"
import script from "./Signalr.vue?vue&type=script&lang=js&"
export * from "./Signalr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf3ce9",
  null
  
)

export default component.exports